import {
  AVA_MODULE_ID,
  DEFENSE_OPTIMIZATION_MODULE_ID,
  DETECTION_RULE_MANAGER_MODULE_ID,
  MAIN_MODULES
} from '@attackiq/constants';

import type { Tenancy } from './useTeams';

const WATCHTOWER_MODULE_ID = '158b33ec-23a9-47da-921a-22cb13de8e3f';
const WATCHTOWER_DEMO_MODULE_ID = '4de054b1-65b8-44f8-94db-8473e3002217';
const EMM_MODULE_ID = '69cea8e5-412b-4eca-aa8e-18929d658858';
const BPM_MODULE_ID = 'aff4da9e-df3f-4bbb-8a62-b8dfb3b2a70a';

const ENTERPRISE_MODULES = [
  BPM_MODULE_ID,
  AVA_MODULE_ID,
  EMM_MODULE_ID,
  WATCHTOWER_MODULE_ID,
  WATCHTOWER_DEMO_MODULE_ID,
  DEFENSE_OPTIMIZATION_MODULE_ID,
  DETECTION_RULE_MANAGER_MODULE_ID
];

// Flex Enhancements
const FLEX_MONTHLY_MODULE_ID = '5a3c96b0-a7cb-497c-8d8e-3b01f22b088a';
const FLEX_YEARLY_MODULE_ID = 'be288143-3cb9-405a-b38b-5eb442a2506c';
const FLEX_PACKAGE_RUNS_MODULE_ID = '3c48c51a-edc3-45ab-b413-bc2dcff4c04d';
const FLAT_RATE_FLEX_MODULES = [FLEX_MONTHLY_MODULE_ID, FLEX_YEARLY_MODULE_ID];
const FLEX_VARIANTS_MODULES = [...FLAT_RATE_FLEX_MODULES, FLEX_PACKAGE_RUNS_MODULE_ID];
const READY_VARIANTS_MODULES = [FLEX_PACKAGE_RUNS_MODULE_ID];

export interface ParsedTenancy
  extends Omit<Tenancy, 'expiration_date' | 'industry' | 'annual_revenue' | 'employee_number'> {
  expiration_date: Date | null;

  // Entitlements
  main: string;
  flex_variant: string | null;
  ready_variant: string | null;
  package_groups: string[];
  enterprise_modules: string[];
  annual_revenue: number;
  industry: string;
  employee_number: number;
}

export const parseExpirationDate = (dateStr: string | null): Date | null => {
  if (!dateStr) return null;

  const [year, month, day] = dateStr.split('-');

  return new Date(Number(year), Number(month) - 1, Number(day));
};

export const getParsedTenancy = (tenancy: Tenancy, availablePackageGroups?: string[]): ParsedTenancy => {
  const packageGroups = availablePackageGroups?.filter(pg => tenancy.modules.includes(pg)) ?? [];

  if (tenancy.modules.includes(AVA_MODULE_ID)) {
    packageGroups.push(AVA_MODULE_ID);
  }

  return {
    ...tenancy,
    expiration_date: parseExpirationDate(tenancy.expiration_date),

    // Entitlements
    main: MAIN_MODULES.find(m => tenancy.modules.includes(m)) ?? '',
    enterprise_modules: tenancy.modules.filter(m => ENTERPRISE_MODULES.includes(m)) ?? [],
    flex_variant: tenancy.modules.find(m => FLEX_VARIANTS_MODULES.includes(m)) ?? null,
    ready_variant: tenancy.modules.find(m => READY_VARIANTS_MODULES.includes(m)) ?? null,
    package_groups: packageGroups,
    annual_revenue: tenancy.annual_revenue ?? 0,
    employee_number: tenancy.employee_number ?? 0,
    industry: tenancy.industry ?? ''
  };
};
